import { lazy, Suspense } from "react";
import LoadingIcon from "~/components/form/LoadingIcon";

const getClientComponent = () => {
  const [client, d] = import.meta.env.MODE.split(":");
  console.log({ client, d, dd: import.meta.env.MODE });
  if (!client) {
    throw new Error("Invalid client. Check package.json.");
  }
  return lazy(() => import(`./${client}/index.tsx`));
};

const DocumentDeclaration = () => {
  const DocumentDeclarationComponent = getClientComponent();

  return (
    <Suspense fallback={<LoadingIcon />}>
      <DocumentDeclarationComponent />
    </Suspense>
  );
};

export default DocumentDeclaration;
